import React from 'react';
import { Form, Select } from 'antd';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'dva';

const AllowedDomains = (props) => {
  const { getFieldDecorator } = props.form;
  const allowedDomains = props.projects.projectDetail.allowed_domains || '';

  const validateValue = (_, values, callback) => {
    /* eslint-disable */
    const domainRegex = /^((?:(?:(?:\w[\.\-\+]?)*)\w)+)((?:(?:(?:\w[\.\-\+]?){0,62})\w)+)\.(\w{2,6})$/;
    /* eslint-enable */
    const invalidInputs = values.filter(value => !value.match(domainRegex));
    if (invalidInputs.length === 0) {
      callback();
    } else if (invalidInputs.length === 1) {
      callback(`${invalidInputs.join('')} is not a valid domain'`);
    } else {
      callback(`${invalidInputs.slice(0, -1).join(', ')} and ${invalidInputs.slice(-1)} are not valid domains`);
    }
  };

  return (
    <Form.Item label={<FormattedMessage id="Component.AccountSettings.New.DomainSection.AllowedDomains" />}>
      {getFieldDecorator('allowed_domains', {
        rules: [{
          required: false,
          validator: validateValue,
        }],
        initialValue: props.isNew ? [] : (allowedDomains ? allowedDomains.split(',') : []),
      })(
        <Select mode="tags" />,
      )}
    </Form.Item>
  );
};

export default connect(({
  projects,
}) => ({
  projects,
}))((injectIntl(AllowedDomains)));



// WEBPACK FOOTER //
// ./src/components/Projects/AllowedDomains/AllowedDomains.js